import React from 'react';
import ReactDOM from 'react-dom';

import 'athenaeum/lib/assets/styles.css';
import Footer from '../src/templates/Footer';

ReactDOM.render(<Footer />, document.getElementById('footer'));



// WEBPACK FOOTER //
// ./footer_entry.js